import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  HEADER_NOTIFICATION_MARK_AS_READ_QUERY_KEY,
  HEADER_NOTIFICATION_MARK_AS_READ_URL,
  HEADER_NOTIFICATION_QUERY_KEY,
} from '@modules/notification/constants';

export default function useHeaderNotificationMarkAsReadMutation(): IContextMutationResult<void, Error, number> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, number>({
    mutationKey: [HEADER_NOTIFICATION_MARK_AS_READ_QUERY_KEY],
    mutationFn: (id) => fetchPost<void>(
      HEADER_NOTIFICATION_MARK_AS_READ_URL,
      {},
      {
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [HEADER_NOTIFICATION_QUERY_KEY] });
    },
  });
}
